<script setup lang="ts">
import { reformatDateString } from '@/helpers/dates'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

interface Props {
  /** Reference object data */
  reference: Pick<ReferenceInterface, 'date' | 'flags'>
}

const { reference } = defineProps<Props>()

defineOptions({
  name: 'ReferenceDate'
})

const { t } = useI18n()

const tooltip = computed(() => {
  if (reference.flags.is_overdue) {
    return t('references.flags.is_overdue')
  }

  return null
})
</script>

<template>
  <p v-tooltip="tooltip" class="flex flex-row items-center">
    <span>
      {{ reformatDateString(reference.date) }}
    </span>
    <VIcon
      v-if="reference.flags.is_overdue"
      icon="$alert-circle-outline"
      size="1rem"
      class="is_overdue ml-0.5"
    />
  </p>
</template>

<style lang="css" scoped>
@reference '../../styles/main.css';

p:has(.is_overdue) {
  @apply text-danger font-semibold;
}
</style>
